import { Empty, Flex, Spin, Table, TableProps } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import { Server } from '../../../../api/server-index';
import { BuildingDto, ClassroomDto } from '../../../../types/dto/building.dto';
import BackButton from '../../../common/buttons/back-button.component';
import Subtitle from '../../../common/titles/subtitle.component';

const BuildingClassrooms = () => {
  const params = useParams();
  const location = useLocation();
  const { t } = useTranslation('buildings');
  const [loading, setLoading] = useState<boolean>(true);
  const [building, setBuilding] = useState<BuildingDto>();

  const fetchBuilding = useCallback(async () => {
    if (params.buildingId) {
      setLoading(true);
      const response = await Server.Buildings.getBuildingById(
        params.buildingId
      );
      if (response?.id) {
        setBuilding(response);
      }
      setLoading(false);
    }
  }, [params.buildingId]);

  useEffect(() => {
    fetchBuilding();
  }, [fetchBuilding]);

  const columns: TableProps<ClassroomDto>['columns'] = [
    {
      key: 'name',
      title: t('classrooms.name'),
      dataIndex: 'name',
      render: (name: string) => name || '-',
    },
  ];

  return (
    <Spin spinning={loading}>
      <BackButton href={`/buildings${location?.search}`} />
      <Flex gap={4} className='mobile-vertical'>
        <Subtitle text={t('classrooms.title')} />
        {building ? (
          <i>
            <Subtitle text={building.name} />
          </i>
        ) : (
          <></>
        )}
      </Flex>
      <Table
        className='mt-1'
        columns={columns}
        dataSource={building?.classrooms}
        rowKey={(val) => val.id}
        pagination={{
          hideOnSinglePage: true,
          pageSize: 10,
        }}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={t('classrooms.empty')}
            />
          ),
        }}
      />
    </Spin>
  );
};

export default BuildingClassrooms;
